module.exports = __webpack_public_path__ + "img/20190612_132334_024.1275e9f5.jpg";